<template>
	<div class='lpo-section-data'>
		<div class='wrapper'>

			<span>{{ lpoAddress }}</span>


			<DataBlock title='Таксационное описание по материалам действующего лесоустройства'>
				<SectionTaxData/>
			</DataBlock>

			<DataBlock title='Особенности участка, не указанные в материалах лесоустройства'>
				<SectionSectionSpecifics/>
			</DataBlock>

			<DataBlock title='Особенности насаждения'>
				<SectionPlantingSpecifics/>
			</DataBlock>

			<DataBlock title='Прочее'>
				<SectionOtherData/>
			</DataBlock>

			<DataBlock title='Примечания'>
				<SectionNotesData/>
			</DataBlock>


			<div class='links-block'>
				<router-link class='right' :to='linkNext'>Далее - Границы и площадь выдела -></router-link>
			</div>

		</div>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';

	import DataBlock from '../CurrentLpo__dataBlock';

	import SectionTaxData from './CurrentLpo__tax';
	import SectionSectionSpecifics from './CurrentLpo__sectionSpecifics';
	import SectionPlantingSpecifics from './CurrentLpo__plantingSpecifics';
	import SectionOtherData from './CurrentLpo__other';
	import SectionNotesData from './CurrentLpo__notes';

	export default {
		name: 'LpoSectionData',

		components: {
			DataBlock,

			SectionTaxData,
			SectionSectionSpecifics,
			SectionPlantingSpecifics,
			SectionOtherData,
			SectionNotesData
		},

		computed: {
			linkNext() { return { name: 'current-lpo-geometry' }; },

			...mapGetters('selectedLpo', [
				'lpoAddress',
			])
		},


	};
</script>

<style scoped src='@/style/wrapper.css'></style>

<style scoped>
	.data-block {
		margin-bottom: 5rem;
	}

	.links-block::after {
		content: '';
		display: table;
		clear: both;
	}

	.link {
		text-decoration: underline;
		cursor: pointer;
		color: blue;
	}
	.link:hover {
		color: darkblue;
	}
	.link.right {
		float: right;
	}
	.right {
		float: right;
	}
</style>